import type { SanityCaseStudyLocation } from "@ouster/shared";

/**
 * Card location label. The design pairs the most specific place with the
 * country as a single "City, Country" tag; `state` stands in for case studies
 * that carry no city, and a country-only location degrades to just the country.
 */
export function formatCaseStudyLocation(location?: SanityCaseStudyLocation): string | null {
  const place = location?.city || location?.state;
  return [place, location?.country].filter(Boolean).join(", ") || null;
}